import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./ProgressBar.module.scss";

const ProgressBar = ({ currentStep, steps }) => {
  const progressPercentage = ((currentStep - 1) / (steps.length - 1)) * 100;

  // Short labels for mobile view
  const mobileLabels = {
    "Writer Profile": "Profile",
    "Toichen": "Toichen",
    "Brainstorming Time": "Brainstorm",
    "Story Building": "Story"
  };

  return (
    <div className={cs(classes.progressContainer)}>
      {/* Desktop Labels - Above Progress Bar */}
      <div className={cs(classes.stepsLabels, classes.desktopLabels)}>
        {steps.map((step, index) => (
          <span
            key={index}
            className={cs(classes.stepLabel, {
              [classes.active]: index + 1 <= currentStep,
              [classes.completed]: index + 1 < currentStep,
            })}
          >
            {step}
          </span>
        ))}
      </div>

      {/* Mobile Labels - Above Progress Bar */}
      <div className={cs(classes.stepsLabels, classes.mobileLabels)}>
        {steps.map((step, index) => (
          <div
            key={index}
            className={cs(classes.mobileStepWrapper, {
              [classes.active]: index + 1 <= currentStep,
            })}
          >
            <div
              className={cs(classes.stepNumber, {
                [classes.activeNumber]: index + 1 === currentStep,
                [classes.completedNumber]: index + 1 < currentStep,
              })}
            >
              {index + 1 < currentStep ? (
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 6L5 9L10 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              ) : (
                index + 1
              )}
            </div>
            <span className={cs(classes.mobileStepLabel)}>
              {mobileLabels[step] || step}
            </span>
          </div>
        ))}
      </div>

      {/* Progress Bar */}
      <div className={cs(classes.progressBarWrapper)}>
        <div className={cs(classes.progressBar)}>
          <div
            className={cs(classes.progressFill)}
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        
        {/* Step Indicators on Progress Bar */}
        {/* <div className={cs(classes.stepIndicators)}>
          {steps.map((step, index) => (
            <div
              key={index}
              className={cs(classes.stepIndicator, {
                [classes.activeIndicator]: index + 1 <= currentStep,
              })}
              style={{
                left: `${(index / (steps.length - 1)) * 100
                 
                }%`
              }}
                          />
          ))}
        </div> */}
      </div>

      {/* Current Step Info for Mobile */}
      <div className={cs(classes.currentStepInfo)}>
        <span className={cs(classes.stepCounter)}>
          Step {currentStep} of {steps.length}
        </span>
        <span className={cs(classes.currentStepName)}>
          {steps[currentStep - 1]}
        </span>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ProgressBar;